/**
 * The Auth0 SPA SDK caches tokens in localStorage under this prefix. Once the shell owns the
 * session nothing reads them, and they should not outlive a logout on a shared device.
 */
const WEB_SDK_CACHE_PREFIX = '@@auth0spajs@@';

/** Returns the number of entries removed, so a caller can report whether there was residue. */
export function clearWebSdkResidue(storage: Storage = window.localStorage): number {
    // Collected before removing: deleting while walking the index shifts the remaining entries.
    const stale = Array.from({ length: storage.length }, (_, i) => storage.key(i)).filter(
        (key): key is string => key?.startsWith(WEB_SDK_CACHE_PREFIX) ?? false
    );
    stale.forEach((key) => storage.removeItem(key));
    return stale.length;
}
